import request from "@/utils/request";

/* 项目域接口：项目 / 答题 / 报告 / 公告 / 智能路由 / 风险对标 / 语音 / 伦理预诊 */

export function AddProject(data) {
  return request({ url: "/Project/Project/AddProject", method: "POST", data });
}

export function DeleteProject(data) {
  return request({ url: "/Project/Project/DeleteProject", method: "Delete", params: data });
}

// 按最新题库复评：重建题目快照（最新题库+板块过滤），项目回到待评估；历史报告保留供复评对比
export function ReevalLatest(data) {
  return request({ url: "/Project/Project/ReevalLatest", method: "POST", params: data });
}

// 最近一次法源广播信息 + 当前用户可复评项目数（项目页待办条）
export function LibraryBroadcastInfo() {
  return request({ url: "/Project/Project/LibraryBroadcastInfo", method: "GET" });
}

export function GetPage(data) {
  return request({ url: "/Project/Project/GetPage", method: "POST", data });
}

export function GetAllPage(data) {
  return request({ url: "/Project/Project/GetAllPage", method: "POST", data });
}

export function GetProjectInfo(data) {
  return request({ url: "/Project/Project/GetProjectInfo", method: "get", params: data });
}

// 【出海板块 bt50 重构 2026-10-05】目的地目录：法域级别 + 法源准入闸门 + 绑定题数 + 出境路径卡
// 依赖法域分级单一事实源（/www/legal-db/jurisdictions.json）与出海板块配置（abroad-board.json）
export function GetAbroadCatalog() {
  return request({ url: "/Project/Project/GetAbroadCatalog", method: "GET" });
}

export function GetQuestion(data) {
  return request({ url: "/Project/Project/GetQuestion", method: "get", params: data });
}

export function Answer(data) {
  return request({ url: "/Project/Project/Answer", method: "POST", data });
}

export function Answers(data) {
  return request({ url: "/Project/Project/Answers", method: "POST", data });
}

export function GenReport(data) {
  return request({ url: "/Project/Project/GenReport", method: "get", params: data });
}

export function GetReportPage(data) {
  return request({ url: "/Project/Report/GetReportPage", method: "POST", data });
}

export function AIExplain(data) {
  return request({ url: "/Project/Project/AIExplain", method: "POST", data });
}

export function AITest(data) {
  return request({ url: "/Project/Project/AITest", method: "get", params: data });
}

export function GetReportState(data) {
  return request({ url: "/Project/Project/GetReportState", method: "get", params: data });
}

export function GetReportAttachment(data) {
  return request({ url: "/Project/Report/GetReportAttachment", method: "get", params: data });
}

export function GetReportDetail(data) {
  return request({ url: "/Project/Report/GetReportDetail", method: "get", params: data });
}

// 法条核验结果
export function GetReportCitations(data) {
  return request({ url: "/Project/Project/GetReportCitations", method: "get", params: data });
}

// OCR 营业执照识别（multipart，Content-Type 由浏览器自动生成）
export function UploadBizLicense(data) {
  return request({ url: "/Project/Project/UploadBizLicense", method: "post", data: data });
}

// 合规 AI 助手问答
export function AskAI(data) {
  return request({ url: "/Project/Project/Ask", method: "get", params: data });
}

// 智能路由出题：评估准备，将未推荐题目填为"不适用"
export function PrepareRoutedEvaluation(data) {
  return request({ url: "/Project/Project/PrepareRoutedEvaluation", method: "post", data });
}

// 公告板块
export function GetAnnouncements() {
  return request({ url: "/Project/Project/GetAnnouncements", method: "get" });
}

export function GetUnreadAnnouncementCount() {
  return request({ url: "/Project/Project/GetUnreadAnnouncementCount", method: "get" });
}

export function MarkAnnouncementRead(data) {
  return request({ url: "/Project/Project/MarkAnnouncementRead", method: "post", params: data });
}

// 智能路由出题：引导题 + 路由推荐
export function GetGuideQuestions(data) {
  return request({ url: "/Project/Project/GetGuideQuestions", method: "get", params: data });
}

export function GetRoutedQuestions(data) {
  return request({ url: "/Project/Project/GetRoutedQuestions", method: "post", data });
}

// 企业资料 AI 识别风险场景
export function AnalyzeEnterpriseProfile(data) {
  return request({ url: "/Project/Project/AnalyzeEnterpriseProfile", method: "post", data });
}

// 复评对比：项目报告列表 + 智能diff对比
export function GetProjectReports(data) {
  return request({ url: "/Project/Report/GetProjectReports", method: "get", params: data });
}

export function GetCompareReport(data) {
  return request({ url: "/Project/Report/GetCompareReport", method: "get", params: data });
}

// 同类案件风险提示（报告→案例库匹配→裁判规则提炼）
export function GetSimilarCaseRisks(data) {
  return request({ url: "/Project/RiskBenchmark/GetSimilarCaseRisks", method: "get", params: data });
}

// 行业对标（同行业风险分位 + 等级分布）
export function GetBenchmark(data) {
  return request({ url: "/Project/RiskBenchmark/GetBenchmark", method: "get", params: data });
}

// 报告语音解读（TTS）
export function GetTtsStatus() {
  return request({ url: "/Project/Tts/TtsStatus", method: "get" });
}

export function GenerateReportVoice(data) {
  return request({ url: "/Project/Tts/GenerateReportVoice", method: "get", params: data });
}

// 伦理板块 P1-P7 预诊题组与判定书
export function GetEthicsPrecheckQuestions() {
  return request({ url: "/Project/EthicsPrecheck/Questions", method: "get" });
}

export function SubmitEthicsPrecheck(data) {
  return request({ url: "/Project/EthicsPrecheck/Submit", method: "post", data });
}

// 报告答题列表（含 LawSourse，用于条文原文折叠展示）
export function GetReportAnswerList(data) {
  return request({ url: "/Project/Report/GetAnswerList", method: "get", params: data });
}
